import React, { useEffect, useState } from "react";
import styled from "styled-components";

import Typography from "components/typography";
import { Colors } from "utils/colors";
import { ReactComponent as BgSvg } from "images/svg/pricing-bg.svg";
import { ReactComponent as BgSvgMobile } from "images/svg/starfield-mobile.svg";
import IndependentCard from "./components/cards/independent-card";
import ProCard from "./components/cards/pro-card";
import LabelCard from "./components/cards/label-card";
import Table from "./components/table";
import Footer from "components/footer";
import Navbar from "components/navbar/landingPage-navabar";

const Pricing = () => {
  const [isMonthly, setIsMonthly] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <Main>
      <Navbar />
      <Bg>
        <BgSvg width={"100%"} height={"100%"} />
      </Bg>
      <MBg>
        <BgSvgMobile width={"100%"} height={"100%"} />
      </MBg>
      <Container>
        <HeaderText>
          <Typography
            mt="6.4"
            m_mt="3.6"
            align="center"
            size="3.6rem"
            m_size="4xl"
            weight="semibold"
            color={Colors.white100}
          >
            Choose Your Perfect Plan For Music Distribution
          </Typography>
          <Typography
            align="center"
            mt="1.6"
            m_mt="0.8"
            color={Colors.grey400}
            size="3xl"
            m_size="m"
          >
            Wether you’re a independent artist, a duo, or managing a label, our
            flexible pricing plans are designed to suit your needs.
          </Typography>
        </HeaderText>

        <Body>
          <Switch>
            <SwitchItem
              active={isMonthly ? "true" : "false"}
              onClick={() => {
                setIsMonthly(true);
              }}
            >
              <Typography>Monthly</Typography>
            </SwitchItem>
            <SwitchItem
              active={!isMonthly ? "true" : "false"}
              onClick={() => {
                setIsMonthly(false);
              }}
            >
              <Typography>Annually</Typography>
            </SwitchItem>
          </Switch>
          <Cards>
            <IndependentCard isMonthly={isMonthly} />
            <ProCard isMonthly={isMonthly} />
            <LabelCard isMonthly={isMonthly} />
          </Cards>
          <Table />
        </Body>
      </Container>
      <Footer />
    </Main>
  );
};

export default Pricing;

const Main = styled.main`
  width: 100%;
  background-color: #0d0d0d;
  @media only screen and (max-width: 769px) {
    overflow: hidden;
    width: 100vw;
  }
`;

const Container = styled.div`
  position: relative;
  padding: 0 1.6rem;
`;

const HeaderText = styled.div`
  width: 44%;
  margin-left: auto;
  margin-right: auto;
  z-index: 5;
  position: relative;
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;

const Bg = styled.div`
  width: 100%;
  position: absolute;
  height: fit-content;
  left: -8.2%;
  /* top: -9%; */

  @media only screen and (max-width: 769px) {
    display: none;
  }
`;

const MBg = styled.div`
  display: none;
  width: 100%;
  position: absolute;
  height: fit-content;

  @media only screen and (max-width: 769px) {
    display: block;
  }
`;

const Body = styled.div`
  width: 90%;
  margin-top: 4rem;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  padding-bottom: 5rem;
`;

const Switch = styled.div`
  padding: 0.3rem;
  border-radius: 0.8rem;
  border: 0.5px solid ${Colors.grey600};
  width: fit-content;
  margin-bottom: 3.2rem;
  display: flex;
  @media only screen and (max-width: 769px) {
    width: 100%;
    margin-bottom: 2.8rem;
  }
`;

const SwitchItem = styled.div<{ active: string }>`
  width: fit-content;
  padding: 0.5rem;
  display: flex;
  border-radius: 0.8rem;
  background-color: ${(props) =>
    props.active === "true" ? Colors.grey700 : ""};
  color: ${(props) =>
    props.active === "true" ? Colors.white100 : Colors.grey500};

  cursor: pointer;
  transition: 0.3s ease-out all;
  @media only screen and (max-width: 769px) {
    width: 50%;
    align-items: center;
    justify-content: center;
    padding: 1.2rem 0;
  }
`;

const Cards = styled.div`
  display: grid;
  grid-template-columns: 31% 31% 31%;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 769px) {
    grid-template-columns: 100%;
    grid-row-gap: 2.4rem;
  }
`;
